import { Component } from "@/types/types"
import { cx } from "@/utils/cx"

export const COMPONENT_NAME = "marketing-section"

export const presets = {}

export interface Props extends Component {
  removeYPadding?: boolean
  removeXPadding?: boolean
}

export function MarketingSection({
  children,
  className,
  testId = COMPONENT_NAME,
  removeYPadding = false,
  removeXPadding = false,
}: Props) {
  return (
    <div
      className={cx(
        `w-full`,
        !removeXPadding && `px-3 sm:px-6 md:px-12 lg:px-16`,
        !removeYPadding && `py-16 md:py-24 lg:py-40`,
        `flex flex-col justify-center mx-auto max-w-[100vw] md:max-w-screen-marketing`,
        className,
      )}
      data-test={testId}
    >
      {children}
    </div>
  )
}
